export default {
    repeatType: "none",
    shuffle: false,
    requestReplayTrack: false
}